var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-parallax',{attrs:{"height":"300","src":"https://cdn.vuetifyjs.com/images/parallax/material2.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }